import type {
  ExpressionErrorInfos,
  ExpressionErrorInput,
} from "./expression.type";

import { isExpressionError } from "@stelar/expression-engine";

import { isError } from "@/utilities/error";
import { isValidObject } from "@/utilities/object";

export const getExpressionErrorInfos = (
  error?: ExpressionErrorInput
): ExpressionErrorInfos | undefined => {
  if (isExpressionError(error)) {
    return { code: error.code, message: error.message };
  }

  if (isError(error)) {
    return { code: "UNEXPECTED_ERROR", message: error.message };
  }

  if (error) {
    const message = getUnknownErrorMessage(error);
    return { code: "UNEXPECTED_ERROR", message };
  }

  return undefined;
};

export const getUnknownErrorMessage = (error: unknown): string => {
  if (typeof error === "string") return error;

  if (
    isValidObject(error) &&
    "message" in error &&
    typeof error.message === "string"
  ) {
    return error.message;
  }

  return "";
};
